/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyBreakdownItem
 */
export interface PropertyBreakdownItem {
    /**
     * Category name => Property value
     * @type {{ [key: string]: string; }}
     * @memberof PropertyBreakdownItem
     */
    brackets: { [key: string]: string; };
    /**
     * Number of visits within given property brackets
     * @type {number}
     * @memberof PropertyBreakdownItem
     */
    numberOfVisits: number;
}

export function PropertyBreakdownItemFromJSON(json: any): PropertyBreakdownItem {
    return PropertyBreakdownItemFromJSONTyped(json, false);
}

export function PropertyBreakdownItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyBreakdownItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brackets': json['brackets'],
        'numberOfVisits': json['number_of_visits'],
    };
}

export function PropertyBreakdownItemToJSON(value?: PropertyBreakdownItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brackets': value.brackets,
        'number_of_visits': value.numberOfVisits,
    };
}

